var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * @hidden
 */
export var normalize = function () {
    var _a;
    var settings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        settings[_i] = arguments[_i];
    }
    return (_a = Object).assign.apply(_a, __spreadArrays([{ allowUnsort: true, mode: 'single' }], settings));
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-grid/dist/es/interfaces/GridSortSettings.js
// module id = 384
// module chunks = 93